import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTableItem from '../../shared/customComponents/customTableItem';
import NominaContent from '../modalDetalleDocumento/components/NominaContent';

const NominasTab = ({ data }) => {
  const { t } = useTranslation('documents');
  const nominaData = data?.meta?.nominaStatus?.inNominaProcess || [];

  return (
    <div className="document-content">
      <div className="tw-flex-row tw-gap-[12px]">
        <h4 className="!tw-m-0 tw-text-[15px] tw-font-semibold tw-text-gray-700">{t('detail.payrollsSection.title')}</h4>
        <div className="tw-border-solid tw-border-[1px] tw-border-gray-200 tw-rounded-[3px] tw-mt-4">
          <div className="tw-bg-gray-50 tw-h-[36px] borderHeaderModalDoc">
            <div className="tw-px-[12px] tw-py-[9px] tw-flex tw-justify-between">
              <p className="tw-text-[12px] tw-font-medium tw-text-gray-700">{t('detail.payrollsSection.nameUserColumn')}</p>
              <div className="tw-flex tw-justify-end tw-pe-[34px]">
                <p className="tw-text-[12px] tw-font-medium tw-text-gray-700 tw-w-[110px] tw-flex tw-justify-end tw-pe-3">{t('detail.payrollsSection.amountColumn')}</p>
                <p className="tw-text-[12px] tw-font-medium tw-text-gray-700 tw-w-[110px] tw-flex tw-justify-end">{t('detail.payrollsSection.statusColumn')}</p>
              </div>
            </div>
          </div>
          {
            nominaData?.length > 0 ?
              <div className="tw-px-2 tw-py-2">
                {nominaData.map((nomina, index) => (
                  <div key={index} className="tw-py-1">
                    <CustomTableItem
                      content={<NominaContent data={nomina} />}
                    />
                  </div>
                ))}
              </div>
              :
              <div className="tw-h-[36px]">
                <div className="tw-px-[12px] tw-py-[9px] tw-flex tw-justify-between">
                  <p className="tw-text-[12px] tw-font-normal tw-text-gray-700">{t('detail.payrollsSection.notAssigned')}</p>
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  );
};

export default NominasTab;
